export enum LANG {
  KO = 'ko',
  EN = 'en',
  CN = 'cn',
  JP = 'jp',
}

export const LANGUAGE_LIST = [
  {
    i18nKey: 'app.language.ko',
    value: LANG.KO,
  },
  {
    i18nKey: 'app.language.en',
    value: LANG.EN,
  },
  {
    i18nKey: 'app.language.cn',
    value: LANG.CN,
  },
  {
    i18nKey: 'app.language.jp',
    value: LANG.JP,
  },
];

export const KEYS = {
  STORAGE_LANG: 'STORAGE_LANG',
  STORAGE_REDIRECT_URL: 'STORAGE_REDIRECT_URL',
  STORAGE_IDB_STORE_LIST: 'STORAGE_IDB_STORE_LIST',
} as const;

// 권한 없는 라우트 접근 에러의 메시지는 다국어라서 name 으로 식별하여 Sentry 수집에서 제외합니다
export const NON_ACCESSIBLE_ROUTE_ERROR_NAME = 'NonAccessibleRouteError';

// NOTE: 앱 경로를 URL 로 풀어 비교할 때만 쓰는 기준 주소입니다. .invalid 는 예약 도메인이라 실제 접속처가 아닙니다
export const ROUTE_PATH_RESOLVE_BASE_URL = 'https://app.invalid';

export const APP_API_URL = import.meta.env.VITE_APP_API_URL;
